<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-card class="hide-overflow">
          <v-card-title>
            <v-toolbar flat color="white">
              <v-toolbar-title>Usuarios</v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
              <v-text-field
                v-model="searchUser"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              >
              </v-text-field>
              <v-spacer></v-spacer>
              <v-btn fab dark :color="temaColor">
                <v-icon @click="nuevoUsuario" dark>add</v-icon>
              </v-btn>

              <!-- <v-btn :disabled="userAsignar" fab dark small :color="usersFilteredList ? 'success' : 'secundary'" @click="usersFilteredList = !usersFilteredList"><v-icon>filter_list</v-icon></v-btn> -->
              <v-spacer></v-spacer>
              <v-btn
                dark
                :color="temaColor"
                class="mb-2"
                @click="usersFilteredDialog = !usersFilteredDialog"
              >
                <v-badge color="purple">
                  <span slot="badge" v-if="totalFiltros > 0">{{
                    totalFiltros
                  }}</span>
                  <span>Filtros</span>
                </v-badge>
              </v-btn>
            </v-toolbar>
          </v-card-title>

          <v-card-text>
            <v-data-table
              rows-per-page-text="Resultados por página"
              :headers="usersControl.headers"
              :items="usersFilterd"
              :search="searchUser"
              :pagination.sync="pagination"
              class="elevation-1"
            >
              <template slot="items" slot-scope="users">
                <td>{{ users.item.nombre || "-" }}</td>
                <td>
                  {{
                    users.item.apellidos.length > 2 ? users.item.apellidos : "-"
                  }}
                </td>
                <td>{{ users.item.email }}</td>
                <td>{{ users.item.tlf || "-" }}</td>
                <td>{{ users.item.rol }}</td>
                <td class="text-xs-right">
                  <a
                    v-if="level > 10 && !tipoListado"
                    class="btn btn-outline-primary btn-sm no-decoration"
                    role="button"
                    @click="deleteUsuario(users.item.idx)"
                  >
                    <v-icon class="mr-2" color="error">mdi-delete</v-icon>
                  </a>
                  <a
                    v-if="!tipoListado"
                    class="btn btn-outline-primary btn-sm no-decoration"
                    role="button"
                    @click="editaUsuario(users.item.idx)"
                  >
                    <v-icon class="mr-2" color="primary">create</v-icon>
                  </a>
                  <a
                    v-else
                    class="btn btn-outline-primary btn-sm no-decoration"
                    role="button"
                    @click="userAsignation(users.item.idx)"
                  >
                    <v-icon class="mr-2" color="primary">how_to_reg</v-icon>
                  </a>
                </td>
              </template>
              <template slot="no-data">
                <v-alert :value="true" color="info" icon="info">
                  No existen documentos :(
                </v-alert>
              </template>
            </v-data-table>
          </v-card-text>

          <!-- Nuevo Usuario -->
          <v-dialog v-model="usersDialog" max-width="500px">
            <!-- <v-btn slot="activator" color="primary" dark class="mb-2">Nuevo Usuario</v-btn> -->
            <v-card>
              <v-card-title>
                <span class="headline">Nuevo Usuario</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap> </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="usersDialog = !usersDialog"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="prueba"
                  :disabled="false"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Filtros -->
          <v-dialog v-model="usersFilteredDialog" max-width="500px">
            <!-- <v-btn v-if="!userAsignar" slot="activator" color="primary" dark class="mb-2">Filtros</v-btn> -->
            <v-card>
              <v-card-title>
                <div>
                  <div class="headline">Configurar Filtros</div>
                  <span class="grey--text"
                    >{{ usersFilterd.length }} Registros coincidentes</span
                  >
                </div>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-combobox
                        v-model="usersFilterOption.rol"
                        :items="usersFiltersRol"
                        label="Rol del usuario"
                        multiple
                      >
                      </v-combobox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="usersFilteredDialog = false"
                  >Cerrar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Usuarios",
  data() {
    return {
      searchUser: "",
      usersFilteredDialog: false,
      userAsignar: false,
      usersFilteredList: true,
      usersFilterOption: {
        rol: []
      },
      usersDialog: false,
      usersControl: {
        headers: [
          { text: "Nombre", align: "left", value: "nombre", sortable: true },
          {
            text: "Apellidos",
            align: "left",
            value: "apellidos",
            sortable: true
          },
          { text: "Email", align: "left", value: "email", sortable: true },
          { text: "Tlf", align: "left", value: "tlf", sortable: true },
          { text: "Rol", align: "left", value: "rol", sortable: true },
          { text: "Accion", align: "right", value: "name", sortable: false }
        ]
      },
      usersFilterExclude: [],
      pagination: {
        sortBy: "name"
      }
    };
  },
  watch: {
    /* listaInmuebles() {
            this.pagination.rowsPerPage = this.pagination.totalItems
        }, */
    pagination(newPag, oldPag) {
      if (newPag !== oldPag) {
        this.navegationControl.usuariosList.pagination = newPag;
      }
    },
    usersFilterOption(newFiltro, oldFiltro) {
      if (newFiltro !== oldFiltro) {
        this.navegationControl.usuariosList.filtros = newFiltro;
      }
    },
    searchUser(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.navegationControl.usuariosList.search = newVal;
      }
    }
  },
  mounted: function() {
    if (this.navegationControl.usuariosList.pagination) {
      this.pagination = this.navegationControl.usuariosList.pagination;
    } else {
      this.pagination.rowsPerPage = this.pagination.totalItems;
    }
    if (this.navegationControl.usuariosList.filtros) {
      this.usersFilterOption = this.navegationControl.usuariosList.filtros;
    }
    if (this.navegationControl.usuariosList.search) {
      this.searchUser = this.navegationControl.usuariosList.search;
    }
  },
  created() {
    this.checkParams();
  },
  computed: {
    ...mapState(["navegationControl"]),
    totalFiltros() {
      let counter = 0;
      const keysFilter = Object.keys(this.usersFilterOption);
      for (const key of keysFilter) {
        counter += this.usersFilterOption[key].length;
      }
      return counter;
    },
    level() {
      return this.$store.getters.getLevel;
    },
    uid() {
      return this.$store.getters.getUserUid;
    },
    temaColor() {
      return this.$store.getters.getTemaColorAdminUI;
    },
    usuariosList() {
      return this.$store.getters.getUsersList;
    },
    usersFilterd() {
      let result = this.usuariosList;
      if (this.usersFilteredList) {
        if (this.usersFilterOption.rol.length > 0) {
          result = result.filter(
            item => this.usersFilterOption.rol.indexOf(item.rol) > -1
          );
        }
      }
      return result.filter(item => !this.usersFilterExclude.includes(item.idx));
    },
    borrar() {
      return this.usuariosList.filter(
        item => !this.usersFilterExclude.includes(item.idx)
      );
    },
    usersFiltersRol() {
      if (this.usuariosList) {
        // const result = this.usuariosList.filter(item => !this.usersFilterExclude.includes(item.idx))
        return this.usuariosList.map(item => item.rol).filter(this.onlyUnique);
      }
      return ["Sin resultados"];
    },
    params() {
      return this.$route.params;
    },
    query() {
      return this.$route.query;
    },
    tipoListado() {
      if (this.params && this.params.tipo) {
        return this.params.tipo;
      }
      return false;
    }
  },
  methods: {
    userAsignation(idx) {
      switch (this.params.tipo) {
        case "inmuebleSelectUser":
          if (this.query && this.query.refCatastral && this.query.idInmueble) {
            const payload = {
              refCatastral: this.query.refCatastral,
              idInmueble: this.query.idInmueble,
              inmuebleUser: this.query.inmuebleUser,
              idUser: idx
            };
            this.$store.dispatch("addUserInmueble", payload);
            this.$router.back();
          }
          break;
        case "inmuebleSelectAdmin":
          if (this.query && this.query.filter) {
            this.usersFilterOption.rol = ["Administrador Fincas"];
          }
          break;
        case "inmuebleSelectTecnico":
          if (this.query && this.query.filter) {
            this.usersFilterOption.rol = ["Tecnico"];
          }
          break;
        case "inmuebleSelectGestor":
          if (this.query && this.query.filter) {
            this.usersFilterOption.rol = ["Gestor"];
          }
          break;
        default:
          break;
      }
    },
    checkParams() {
      if (this.tipoListado) {
        switch (this.params.tipo) {
          case "inmuebleSelectUser":
            if (this.query && this.query.filter) {
              this.usersFilterOption.rol = ["Usuario"];
            }
            if (this.query && this.query.inmuebleUser) {
              /* const inmueble = this.query.inmuebleUser
                            const userMap = this.$store.getters.getUsersArray.filter(item => {
                                return {
                                    idx: item.idx,
                                    inmuebles: item.data.private.inmuebles || []
                                }
                            }) */
              this.usersFilterExclude = this.$store.getters.getUsersInmuebles
                .filter(item =>
                  item.inmuebles.includes(this.query.inmuebleUser)
                )
                .map(item => item.idx);
            }
            break;
          case "inmuebleSelectAdmin":
            if (this.query && this.query.filter) {
              this.usersFilterOption.rol = ["Administrador Fincas"];
            }
            break;
          case "inmuebleSelectTecnico":
            if (this.query && this.query.filter) {
              this.usersFilterOption.rol = ["Tecnico"];
            }
            break;
          case "inmuebleSelectGestor":
            if (this.query && this.query.filter) {
              this.usersFilterOption.rol = ["Gestor"];
            }
            break;
          default:
            break;
        }
      }
    },
    prueba() {
      // code
    },
    deleteUsuario(idx) {
      if (!confirm(`¿ Seguro que desear eliminar a este usuario ?`)) {
        return;
      }
      this.$store.dispatch("deleteUsuario", idx);
    },
    nuevoUsuario() {
      // usersDialog = !usersDialog
      // 1 - Determinar el ID del usuario
      const aleat = this.aleatorioId();
      const date = this.fechaObject().timeStamp;
      const cadena = window.btoa(`${aleat}${date}`.toString());
      // eslint-disable-next-line
            console.log(cadena)
      // 2 - Guardar en Base de datos nuevoUsuario
      this.$store.dispatch("nuevoUsuario", cadena); //.then(() => {
      // console.log('listo')
      // 3 - Ir al perfil para cumplimentar
      // /dashboard/perfil/NUI0YzNaOS0xNTQwODg5NzEyNDM5?filter=Usuario&refCatastral=8874705YH1487D&idInmueble=0002&inmuebleUser=8874705YH1487D0002SS
      // -> /user/123
      // this.$router.push(lnk)
      //})
      const lnk = `/dashboard/perfil/${cadena}`;
      this.$router.push({
        path: lnk,
        params: this.$route.params,
        query: this.$route.query
      });
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    editaUsuario(idx, categoria = "user") {
      // consoleLog(`Editar usuario: ${idx} como ${categoria}`)
      if (idx) {
        // this.userEdit(idx)
        const lnk = `/dashboard/perfil/${idx}`;
        this.$router.push(lnk);
      } else {
        // consoleLog(`Agregar nuevo usuario ${categoria}`)
      }
      return categoria;
    },
    fechaObject(dd = null) {
      let d = new Date();
      if (dd) {
        if (d.getHours() === dd.getHours()) {
          d = dd;
        }
      }
      let dia = `0${d.getUTCDate()}`;
      let mes = `0${d.getMonth() + 1}`;
      const year = d.getFullYear();
      let hora = `0${d.getHours()}`;
      let minuto = `0${d.getMinutes()}`;
      let segundo = `0${d.getSeconds()}`;

      dia = dia.substr(-2, 2);
      mes = mes.substr(-2, 2);
      hora = hora.substr(-2, 2);
      minuto = minuto.substr(-2, 2);
      segundo = segundo.substr(-2, 2);

      const result = {
        formatEU: `${dia}/${mes}/${year}`,
        formatEUextend: `${year}${mes}${dia}${hora}${minuto}${segundo}`,
        timeStamp: d.getTime()
      };

      return result;
    },
    aleatorioId() {
      let result = "";
      const uid = this.uid;
      let uidTri = Math.floor(uid.length / 3);
      uidTri = uidTri > 9 ? 9 : uidTri;
      const cadena = [
        uid.slice(0, uidTri),
        uid.slice(uidTri, uidTri * 2),
        uid.slice(uidTri * 2, uid.length)
      ];
      for (let index = 0; index < 3; index++) {
        const i = Math.floor(Math.random() * uidTri);
        const cad = cadena[index].substr(i, 1);
        result += `${i}${cad}`;
      }
      result += `${uidTri}-`;
      return result;
    }
  }
};
</script>
